<script setup lang="ts">
  import { useBranchLogo } from '@/entities/Branch';

  interface Props {
    date: string;
  }

  defineProps<Props>();

  const { currentLogoUrl, handleLogoError, DEFAULT_LOGO } = useBranchLogo();
</script>

<template>
  <div class="px-6 pt-4 overflow-x-auto">
    <table class="w-full border-collapse border border-gray-07 mb-0">
      <tbody>
        <tr>
          <td
            rowspan="2"
            class="border border-gray-07 w-50 text-center bg-white-01"
          >
            <div class="flex flex-col items-center px-4 py-3">
              <img
                :src="currentLogoUrl"
                alt="Logo"
                data-print-logo
                class="max-w-[140px] max-h-[70px]"
                :class="{ 'dark:invert': currentLogoUrl === DEFAULT_LOGO }"
                @error="handleLogoError"
              />
            </div>
          </td>
          <td class="border border-gray-07 p-3 text-center">
            <div class="text-base font-medium text-gray-07">
              DADOS
            </div>
          </td>
          <td class="border border-gray-07 p-3 text-center w-36">
            <div class="text-base font-medium text-gray-07">
              DA05.4
            </div>
          </td>
          <td class="border border-gray-07 p-3 text-center w-36">
            <div class="text-base font-medium text-gray-07">
              {{ date }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            class="border border-gray-07 p-3 text-center"
          >
            <div class="text-base font-medium text-gray-07">
              LISTA DE DISTRIBUIÇÃO INTERNA DE DOCUMENTOS FÍSICOS DO SGQ
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
